import { Box, SxProps, Theme } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
  sx?: SxProps<Theme>
}

const FixedWidthContainer = ({ children, sx }: Props) => {
  return <Box sx={{ maxWidth: '80%', margin: '0 auto', ...sx }}>{children}</Box>
}

export default FixedWidthContainer
